export const images = {
    logo : require("../assets/images/logo.png"),
    viewIcon: require("../assets/images/EyeIcon.png"),
    eyeIcon: require("../assets/images/EyeIcon.png"),
    eyecloseIcon: require("../assets/images/EyecloseIcon.png"),
    totalOrder: require("../assets/images/total-order.png"),
    packed: require("../assets/images/packed.png"),
    dispachted: require("../assets/images/delivery-truck-with-circular-clock.png"),
    production_plan: require("../assets/images/production_planning.png"),
    packing: require("../assets/images/packing.png"),
    dispatch_summary: require("../assets/images/dispatch_summary.png"),
    production_anl: require("../assets/images/production_analytic.png"),
    extruder: require("../assets/images/extruder.png"),
    minimizeScreen: require("../assets/images/Minimize-screen.png"),
    passwordImg: require("../assets/images/PasswordImg.png"),
    editPencil: require("../assets/images/edit-pencil.png"),
    printer: require("../assets/images/print.png"),
    dummyQRcode: require("../assets/images/qr_code_dummy.png"),
    qrCode: require("../assets/images/qr_code.png"),
    deleteIcon: require("../assets/images/delete_icon.png"),
    settingIcon: require("../assets/images/setting.png"),
    addIcon: require("../assets/images/add.png"),
    previewQrCode: require("../assets/images/preview_qr_code.png"),
    printIcon: require("../assets/images/printIcon.png"),
    sheetIcon : require("../assets/images/sheetIcon.png"),
    pdfDownloadIcon: require("../assets/images/pdfDownload_icon.png"),
    datePickerIcon: require("../assets/images/date_picker_icon.png"),
    excelIcon: require("../assets/images/ExcelLogo.png"),
}